/**
 * lot X3 — résilience réseau partagée.
 *
 * Le serveur qui redémarre (déploiement) ou une coupure chez l'utilisateur produisaient une
 * erreur technique brute. Ici : bandeau « Mise à jour en cours », réessais à intervalle
 * croissant, puis abandon propre.
 *
 * ⚠️ À appliquer à CHAQUE instance axios : une instance créée par `axios.create()`
 * n'hérite PAS des intercepteurs de l'instance par défaut (le défaut trouvé en recette :
 * la liste des biens passe par `services/api.js` et n'était donc pas couverte).
 * ⚠️ Le 401 n'est jamais traité ici : une déconnexion doit rester une déconnexion.
 */
export const EVENEMENT_RESEAU = 'komerces:reseau';

const ATTENTES = [1000, 3000, 6000];

export const signalerReseau = (indisponible) => {
  // Drapeau global : si la panne survient avant le montage du bandeau, l'état initial le relit.
  window.__komercesReseauKO = Boolean(indisponible);
  window.dispatchEvent(new CustomEvent(EVENEMENT_RESEAU, { detail: { indisponible: Boolean(indisponible) } }));
};

export const estPanneReseau = (error) => (
  Boolean(error) && (!error.response || [502, 503, 504].includes(error.response.status))
);

/** Rejoue la requête après une attente croissante. `null` = on abandonne, l'erreur suit son cours. */
export const rejouerApresPanne = async (error, instance) => {
  const cfg = error?.config;
  if (!cfg) return null;
  cfg.__essaisReseau = (cfg.__essaisReseau || 0) + 1;
  if (cfg.__essaisReseau > ATTENTES.length) {
    signalerReseau(false);
    return null;
  }
  signalerReseau(true);
  await new Promise((r) => setTimeout(r, ATTENTES[cfg.__essaisReseau - 1]));
  return instance.request(cfg);
};

/** Pose la résilience réseau sur une instance axios (ou sur l'instance par défaut). */
export const installerResilienceReseau = (instance) => {
  instance.interceptors.response.use(
    (response) => {
      if (window.__komercesReseauKO) signalerReseau(false);
      return response;
    },
    async (error) => {
      if (estPanneReseau(error) && error?.config) {
        const rejoue = await rejouerApresPanne(error, instance);
        if (rejoue) return rejoue;
      }
      return Promise.reject(error);
    },
  );
};
